import { createGlobalStyle } from 'styled-components';

export const DocStyles = createGlobalStyle`
  .monavate-docs-redocly {
    .api-content {
      max-width: 100%;
      width: 100%;

        .react-tabs__tab-panel>div ul.obj.collapsible li .hoverable .token.string {
            // color: ${(props) => props.theme['Content/primary']} !important;
        }
        table thead tr th,
        table tbody tr td {
            border-bottom-color: ${(props) => props.theme['Borders/quiet']} !important;
        }

      & > div {
        margin-bottom: 60px;
        min-height: 0;
      }

      [data-section-id^="operation"] {
        & > div:first-child {
          width: calc(100% - 43%);
        }
        
        & > div:last-child {
          padding-top: 40px;
          width: 43%;
          padding-right: 0;

          & > div > button {
            border-radius: 0;
            background: ${(props) => props.theme['Surface/emphasis']}; 
            padding-right: 50px;
            color: ${(props) => props.theme['Accent/primary']};

            p {
              display: inline-block;
              margin: 0;
            }
          }
        }
      }

      [type~="get"], [type~="post"], [type~="put"], [type~="delete"], [type~="patch"] {
        text-align: center;
        height: 24px;
        border: 1px solid #555;
        background: #ccc;
        border-radius: 16px;
        color: #000;
        text-transform: uppercase;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 16px;
        letter-spacing: 0.5px;
      }

      [type~="get"] {
        background: #c2ffcf;
        border-color: #5e9767;
        color: #3f6545;
      }
      [type~="post"] {
        background: #fff6a7;
        border-color: #d1af57;
        color: #b84e12;
      }
      [type~="put"] {
        background: #DFDCF8;
        border-color: #8073E5;
        color: #6F4DA1;
      }
      [type~="delete"] {
        background: #ffdade;
        border-color: #f8001d;
        color: #c60017;
      }
      [type~="patch"] {
        background: #cde6f6;
        border-color: #3aa2e8;
        color: #296a98;
      }

        h5 > span + div,
        span.property-name + div, p > code, td[kind="field"] > div {
            color: ${(props) => props.theme['Status/danger/content']} !important;
        }

        [data-section-id^="operation"] > div:first-child div:has(> select.dropdown-select) {
            border: 1px solid ${(props) => props.theme['Status/neutral/bg']} !important;
            background-color: ${(props) => props.theme['Status/neutral/bg']} !important;
            color: ${(props) => props.theme['Content/primary']} !important;
        }

        [data-section-id^="operation"] > div:last-child div:has(> select.dropdown-select) {
            background-color: transparent !important;
            color: ${(props) => props.theme['Content/primary']} !important;
        }

      h1, .api-info h1 {
        color: ${(props) => props.theme['Content/primary']};
        font-size: 20px;
        font-weight: 700;
        line-height: 28px;
      }
      h2 {
        color: ${(props) => props.theme['Content/primary']};
        font-size: 20px;
        font-weight: 700;
        line-height: 28px;
      }
      h3 {
        color: ${(props) => props.theme['Content/secondary']};
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        border-bottom: 1px solid ${(props) => props.theme['Borders/quiet']};
      }
      h5, .sc-eGgGjL {
        color: ${(props) => props.theme['Content/secondary']};
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;

          span {
              color: ${(props) => props.theme['Content/primary']} !important;
              font-weight: 400;
              /* Можна додати моноширинний шрифт, щоб виглядало як код */
              font-family: Courier, monospace;
          }
      }
      .sc-eGgGjL {
        border-bottom: 1px solid ${(props) => props.theme['Borders/quiet']};
      }
        table tbody tr td div div span > span {
        color: ${(props) => props.theme['Content/primary']};
            background: ${(props) => props.theme['Status/neutral/bg']} !important;
        }

        h3 ~ div > button:has(div[html*="invalid request error"]),
        h3 ~ div > button:has(div[html*="not found error"]),
        h3 ~ div > button:has(div[html*="precondition failed error"]),
        h3 ~ div > button:has(div[html*="Link expired"]) {
            background: ${(props) => props.theme['Status/danger/bg']} !important;
            color: ${(props) => props.theme['Content/primary']} !important;
            border: 1px solid ${(props) => props.theme['Status/danger/border']} !important;
        }

        h3 ~ div > button:has(div[html*="Link expired"]){
            color: ${(props) => props.theme['Content/primary']} !important;
            background: ${(props) => props.theme['Status/danger/bg']} !important;
            
            svg {
                color: ${(props) => props.theme['Content/primary']} !important;
                
                polygon {
                    fill: ${(props) => props.theme['Content/primary']} !important;
                }
            }
        }

        h3 ~ div > button[aria-expanded], h3 ~ div > button[disabled] {
            background: ${(props) => props.theme['Status/success/bg']} !important;
            color: ${(props) => props.theme['Content/primary']} !important;
        }
        h3 ~ div > button:has(div[html*="invalid request error"]) svg *,
        h3 ~ div > button:has(div[html*="not found error"]) svg *,
        h3 ~ div > button:has(div[html*="precondition failed error"]) svg * {
            fill: ${(props) => props.theme['Content/primary']} !important;
            color: ${(props) => props.theme['Content/primary']} !important;
        }

        h3 ~ div > button[aria-expanded] svg * {
            fill: ${(props) => props.theme['Content/primary']} !important;
            color: ${(props) => props.theme['Content/primary']} !important;
        }
        

        h3 ~ div > button:focus,
        h3 ~ div > button:focus-visible {
            outline: none !important;
            box-shadow: none !important;
        }

        button[aria-expanded="true"] + div h5 ~ div > div > button:not(span + div > button){
            background: ${(props) => props.theme['Status/neutral/bg']} !important;
            border-color: ${(props) => props.theme['Status/neutral/bg']} !important;
        }

        ${(props) =>
            props.theme.mode === 'dark' &&
            `
                span + div > button {
                    color: ${props.theme['Content/inverse']} !important;
                }
            `}

        button + div[aria-hidden] {
            background: ${(props) => props.theme['Surface/page']} !important;
            border: 1px solid ${(props) => props.theme['Borders/quiet']} !important;
            border-radius: 0; /* Наприклад, закруглюємо тільки низ */
        }
        div[role="button"][tabindex="0"]:has(span) {
            background-color: ${(props) => props.theme['Surface/secondary']} !important;
            border: 1px solid ${(props) => props.theme['Borders/quiet']} !important;
            border-radius: 0px !important;
        }
        div[role="button"] > div {
            background: ${(props) => props.theme['Surface/secondary']} !important;
        }

        td[colspan="2"] > div {
            background: ${(props) => props.theme['Surface/section']} !important;
            margin-top: 8px;
        }

      p { font-size: 14px; }
      [data-role="redoc-description"] {
        font-size: 16px;
        line-height: 24px;
      }
      .property-name {
        color: ${(props) => props.theme['Content/primary']};
        font-family: Courier, monospace;
        font-size: 14px;
      }

      ul.react-tabs__tab-list {
        padding-left: 2px;
        margin-left: -2px;
        margin-bottom: 15px;

        li {
          display: inline-block;
          width: 80px;
          padding: 9px 16px;
          background: transparent;
          color: ${(props) => props.theme['Content/secondary']};
          text-align: center;
          font-size: 14px;
            font-weight: 400;
          border-bottom: 2px solid ${(props) => props.theme['Borders/quiet']};
          border-radius: 0;
          margin: 0;

          &:hover, &.tab-error:hover, &.tab-success:hover {
            background: ${(props) => props.theme['Surface/primary']} !important;
            color: ${(props) => props.theme['Content/primary']};
            border-bottom: 2px solid ${(props) => props.theme['Content/primary']} !important;
            border-radius: 0;
          }

          &.react-tabs__tab--selected {
              background: ${(props) => props.theme['Surface/primary']} !important;
              color: ${(props) => props.theme['Content/primary']};
              border-bottom: 2px solid ${(props) => props.theme['Content/primary']} !important;
            &:focus {
              border: none;
              outline: none;
            }
          }
        }
      }

      .react-tabs__tab-panel--selected {
        padding: 28px 16px 20px;
        background: ${(props) => props.theme['Surface/emphasis']} !important;
      }

      .react-tabs__tab-panel {
        & > div {
          padding: 0 !important;
            
            & > div:first-child {

                & > span {
                    color: ${(props) => props.theme['Content/overlay']} !important;
                }
            }
          
          ul.obj.collapsible {
            margin-left: 40px !important;
            li .hoverable {
              .token.string, .token.number, .token.boolean {
                color: ${(props) => props.theme['Content/overlay']};
              }
            }
            a { color: ${(props) => props.theme['Content/primary']} !important; }
          }
        }

        button, .sc-emwzcK button, .token.punctuation, .collapser {
          color: ${(props) => props.theme['Accent/primary']} !important;
        }

        /* Copy-button tooltip ("Copied"): redoc hardcodes a white background/border, which
           reads as a stray white box in dark mode. */
        button > div > div {
          background: ${(props) => props.theme['Surface/secondary']} !important;
          border: 1px solid ${(props) => props.theme['Borders/quiet']} !important;
          border-radius: 0 !important;
          box-shadow: none !important;
          /* Chromium clips the border-bottom on this GPU-composited, translateX-positioned
             tooltip unless it's forced onto its own backface-visible layer. */
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
        }

        button > div > div > div:first-child {
          background: transparent !important;
          color: ${(props) => props.theme['Content/primary']} !important;
        }

        /* Tooltip pointer, built from redoc's CSS-triangle arrow: enlarge it to become
           the "border" layer, then draw a same-size-minus-1px triangle via ::after in the
           tooltip's own background so the pointer reads as part of the bordered box
           instead of a borderless sliver blending into the page. */
        button > div > div > div:nth-child(2) {
          border-left-width: 6px !important;
          border-right-width: 6px !important;
          border-top-width: 6px !important;
          border-top-color: ${(props) => props.theme['Borders/quiet']} !important;
          bottom: -6px !important;
          margin-left: -6px !important;
        }

        button > div > div > div:nth-child(2)::after {
          content: '';
          position: absolute;
          top: -1px;
          left: 1px;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-top: 5px solid ${(props) => props.theme['Surface/secondary']};
        }

        label {
          color: #A6A8AA;
          font-size: 12px;
          font-weight: 700;
        }
      }

      .token.punctuation {
        margin-left: 5px;
      }

      div:after {
        border: none !important;
      }
    }

    .menu-content {
      display: none;
    }

      table tbody tr td div div span > span {
          border-radius: 0 !important;
          background: #DFEBEE;
      }
  }

  .sc-dXNkBG {
    padding-right: 0;
  }

  button[data-test-id="docs-scroll-to-top-button"] {
    background: ${(props) => props.theme['Surface/emphasis']} !important;
  }
  
  .monavate-docs-redocly .api-content  button[aria-expanded="true"] + div h5 ~ div > div > button:not(span + div > button) {
      background: inherit !important;
      color: ${(props) => props.theme['Content/primary']} !important;
  }
`;
